import {
  mdiDeleteOutline,
  mdiPlusCircle
} from "@mdi/js";
import Icon from "@mdi/react";
import { Button, Tooltip } from "@mui/material";
import {
  OptActionToolbar,
  OptBackdrop,
  OptConfirmationDialog,
  OptGridRef,
  OptGridRequest,
} from "@optsol/react";
import { useSnackbar } from "notistack";
import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Colors } from "../../../compartilhado/colors";
import { SearchRequest } from "../../../compartilhado/types/SearchRequest";
import { FiltroBusca } from "../../../componentes/filtro";
import { OptGridContainer } from "../../../componentes/OptGridContainer";
import { OptSideLayoutContentCustom } from "../../../componentes/optSideLayoutContentCustom/OptSideLayoutContentCustom";
import { EVENTO_FORM_INITIAL_STATE } from "../../../constantes/EventoFormInitialState";
import { OCORRENCIA_FORM_INITIAL_STATE } from "../../../constantes/OcorrenciaFormInitialState";
import { TipoInput } from "../../../enums/tipoInput";
import { OcorrenciaSearchResponse } from "../../../modelos/dtos/OcorrenciaSearchResponse";
import { EventoFormModel } from "../../../modelos/evento/eventoFormModel";
import { OcorrenciaFormModel } from "../../../modelos/ocorrencia/ocorrenciaFormModel";
import { OcorrenciaModel } from "../../../modelos/ocorrencia/ocorrenciaModel";
import { PaginatedSearchRequest } from "../../../modelos/search/PaginatedSearchRequest";
import { Rotas } from "../../../rotas";
import { useEventosService } from "../../../servicos/eventos.service";
import { useOcorrenciasService } from "../../../servicos/ocorrencias.service";
import styles from "./styles/gridOcorrencia.module.scss";
import { PerfilUsuario } from "../../../enums/PerfilUsuario";

export const GridOcorrencia = () => {
  const { idEvento } = useParams<{ idEvento?: string }>();
  const [filtro, setFiltro] = useState<OcorrenciaFormModel>();
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
  const [confirmandoExclusao, setConfirmandoExclusao] = useState<boolean>(false);
  const [ocorrencia, setOcorrencia] = useState<OcorrenciaFormModel>(OCORRENCIA_FORM_INITIAL_STATE);
  const [evento, setEvento] = useState<EventoFormModel>(EVENTO_FORM_INITIAL_STATE);
  const [ocorrenciaSelecionada, setOcorrenciaSelecionada] = useState<OcorrenciaFormModel>();
  const { buscarGridOcorrenciaPaginated, removerOcorrencia } = useOcorrenciasService();
  const { carregarEventoPorId } = useEventosService()
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [abrirModalPontoEmbarque, setAbrirModalPontoEmbarque] = useState<boolean>(false);
  const [abrirModalEmpresa, setAbrirModalEmpresa] = useState<boolean>(false);

  const { verificarAutorizacao } = useEventosService();

  const opcoesFiltro = [
    { texto: "Início Data do Evento", valor: 'inicioIntervaloData', tipoInput: TipoInput.Data },
    { texto: "Fim Data do Evento", valor: 'fimIntervaloData', tipoInput: TipoInput.Data }

  ];

  function pesquisaComFiltro(filtro: OcorrenciaFormModel) {
    setFiltro(filtro);
  }

  const carregar = async (
    query: OptGridRequest,

  ) => {
    const request: SearchRequest<PaginatedSearchRequest> = {
      page: query.page,
      pageSize: query.pageSize,
      filtro: { ...filtro, idEvento }
    };
    return buscarGridOcorrenciaPaginated(request);
  };

  function onRowClick(rowData?: OcorrenciaModel) {
    if (rowData) {
    }
  }

  const gridRef = useRef<OptGridRef>(null);
  function recarregar() {
    gridRef.current?.refresh();
  }

  async function onClickDeleteItemHandler() {
    setConfirmandoExclusao(false);
    setDeleteLoading(true);
    try {
      await removerOcorrencia(ocorrencia.id!);
      setDeleteLoading(false);
      enqueueSnackbar(`Registro excluído com sucesso!`, { variant: "success" });
      setOcorrencia(OCORRENCIA_FORM_INITIAL_STATE);
      recarregar();
    } catch {
      setDeleteLoading(false);
    }
  }

  async function onClickFecharPontoEmbarque() {
    setAbrirModalPontoEmbarque(false);
  }

  async function onClickFecharEmpresa() {
    setAbrirModalEmpresa(false);
  }

  function cancelarExclusao() {
    setConfirmandoExclusao(false);
  }

  function cadastrarOcorrencia() {
    history.push(`/ocorrencias/cadastro/${idEvento}`);
  }

  async function carregarEvento(idEvento: string) {
    const evento = await carregarEventoPorId(idEvento) as unknown as EventoFormModel;
    setEvento(evento);
  }

  useEffect(() => {

    if (idEvento) {
      carregarEvento(idEvento);
    }

    if (gridRef.current) {
      recarregar();
    }
  }, [filtro]);


  useEffect(() => {
    (async () => {
      verificarAutorizacao([PerfilUsuario.Administrador, PerfilUsuario.Operacao, PerfilUsuario.Gerente, PerfilUsuario.Consultor]);
    })()
  }, []);

  return (
    <>
      {/* <GridPontoEmbarquePorOcorrencia 
        open={abrirModalPontoEmbarque}
        onClose={onClickFecharPontoEmbarque}
        idOcorrencia={ocorrenciaSelecionada?.id!}
      /> */}
      {/* <GridEmpresasPorOcorrencia
        ocorrencia={ocorrenciaSelecionada}
        recarregar={recarregar}
      /> */}
      <OptConfirmationDialog
        open={confirmandoExclusao}
        title="Excluir Data do Evento"
        icon={{ path: mdiDeleteOutline, color: Colors.red }}
        onCancel={cancelarExclusao}
        onClose={cancelarExclusao}
        onConfirm={onClickDeleteItemHandler}
      >
        Deseja confirmar a exclusão da data do evento? <br /> Essa operação não poderá ser desfeita.
      </OptConfirmationDialog>

      <OptBackdrop open={deleteLoading} />
      <OptSideLayoutContentCustom>
        <OptActionToolbar
          goBackRoute={Rotas.Eventos.Principal}
          title={`${evento.nome}`}
          background={Colors.white}
          color={Colors.gray1}
          clearMargin
        ></OptActionToolbar>
        <OptGridContainer>
          <FiltroBusca opcoes={opcoesFiltro} pesquisa={pesquisaComFiltro} />
          <div className={styles.ButtonSection}>
            <Tooltip title={"Cadastrar nova data"}>
              <Button
                variant="contained"
                color="info"
                style={{ marginRight: "5px", marginBottom: "11px" }}
                placeholder="Cadastrar nova data"
                size="large"
                onClick={cadastrarOcorrencia}
              >
                Cadastrar Nova Data <Icon path={mdiPlusCircle} size={1} color={Colors.primary} />
              </Button>
            </Tooltip>
          </div>
        </OptGridContainer>
        {/* <GridOcorrenciaView
          onRowClick={onRowClick}
          carregar={carregar}
          
          gridRef={gridRef}
        /> */}
      </OptSideLayoutContentCustom>
    </>
  );
};
